import PropTypes from "prop-types";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { useDeviceInfo } from "@swa-ui/browser";
import { withFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  StateAndCountryAutocomplete,
  stateAndCountryAutocompletePropTypes,
} from "../StateAndCountryAutocomplete";
import { STATE_SCHEMA_FIELD_NAME } from "./StateFormField.schema";

const MAX_ITEMS_TO_DISPLAY = 5;

/**
 * A form field component for selecting US states.
 */

// TODO: Await UX feedback from the Seat Map decision tracker on whether to replace the current autocomplete fields with dropdowns.

export const StateFormField = (props) => {
  const { componentProps, disabled, name = STATE_SCHEMA_FIELD_NAME } = props;
  const { isSmallOrMedium } = useDeviceInfo();

  return withFormField(StateAndCountryAutocomplete, { useController: true })(getFormFieldProps());

  function getFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("StateFormField__ARIA"),
        list: getStatesData(),
        ...(isSmallOrMedium && { maxItemsToDisplay: MAX_ITEMS_TO_DISPLAY }),
        noMatchFoundText: i18n("StateFormField__NO_MATCH_FOUND"),
        ...componentProps,
      },
      disabled,
      label: i18n("StateFormField__LABEL"),
      name,
    };
  }

  function getStatesData() {
    const statesData = getBootstrapData("states-data")?.[0]?.statesData?.map(
      ({ code, stateName }) => ({
        label: stateName,
        value: code,
      })
    );

    return statesData;
  }
};

export const stateFormFieldPropTypes = {
  /** Component props for StateAndCountryAutocomplete component. */
  componentProps: PropTypes.shape(stateAndCountryAutocompletePropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

StateFormField.propTypes = stateFormFieldPropTypes;
